<div [formGroup]="formGroup">
    <mat-form-field class="mat-form-field-fluid">
        <mat-select #select [multiple]="multiple" [formControlName]="controlName" [placeholder]="placeholder"
         (openedChange)="onOpenedChange($event)">
            <div *ngIf="allOptionEnabled && multiple" class="m-3">
                <mat-checkbox [(ngModel)]="allSelected" [ngModelOptions]="{standalone: true}"
                    (change)="toggleAllSelection()">{{ 'COMMON.ALL' | translate}}</mat-checkbox>
            </div>
            <input *ngIf="filterEnabled" #selectFilterInput
                placeholder="{{'INPUT.SELECT-FILTER' | translate}}" 
                class="select-filter"
                (keydown)="$event.stopPropagation()"
                (keyup)="onFilterSelectKeyUp($event)" (change)="onSelectItem()">
            <mat-option *ngIf="allOptionEnabled && !multiple" [value]="[]">
                {{ 'COMMON.ALL' | translate}}
            </mat-option>
            <ng-container *ngFor="let item of _items$ | async">
                <mat-option *ngIf="itemIs('object', item)"
                    (click)="optionClick(item.id)" [value]="item.id">
                    {{item.description | translate}}
                </mat-option>
                <mat-option *ngIf="itemIs('string', item)"
                    (click)="optionClick(item)" [value]="item">
                    {{ item }}
                </mat-option>
            </ng-container>
        </mat-select>
            <!-- errors -->
            <mat-hint *ngIf="formGroup.get(controlName).errors?.required">
                {{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}}
            </mat-hint>
    </mat-form-field>
</div>
